import { BiErrorAlt, BiTable } from "react-icons/bi"
import { AlertType, barraVermelhoAzul, bgBlue, bgRed, CFOP, classBorderLabelDark, classBt, classbtAzul, classbtColunasVermelho, classbtVermelho, classInput, classInputDark, classLabel, classLabelDark, CstICMS, focusLabelRed, focusRed, GradeProduto, InputsRefs, KEY_CODE_ENTER, NFEntraItem, Produto, RegimeTributarioType } from "../../Utils/Types"
import React, { useCallback, useEffect, useRef, useState } from "react"
import { FaFolderClosed, FaTableList } from "react-icons/fa6"
import { SearchBox } from "../SearchBox/SearchBox"
import { Funcoes } from "../../Utils/Funcoes"
import { AttributesNFEntrada, NotaEntradaService } from "../../Pages/NotasEntrada/NotaEntradaService"
import { FeedbackMessage } from "../FeedbackMessage/feedback-message"
import { ProdutoService } from "../../Pages/Products/ProdutoService"
import { IoSearch } from "react-icons/io5"
import moment from "moment"
import { MdPhotoCamera } from "react-icons/md"
import { FaRegQuestionCircle } from "react-icons/fa"
import { Tooltip } from 'react-tooltip'
import enter from '../../assets/imagens/enter.png'
import { ModalLancaGradeProdutos } from "./modal-lanca-grad-produtos"

type Props = {
    visible: boolean,
    loading: boolean,
    handleModalClose: () => void,
    buttonConfirmClick: (item: NFEntraItem, numItem: number) => void,
    regimeTributario: RegimeTributarioType,
    attributes: AttributesNFEntrada,
    idNF: number,
    nitemNF: number,
    idForn: number
}

export const ModalLancaItemNF = React.memo(({ visible, loading, regimeTributario, handleModalClose, buttonConfirmClick, idNF, nitemNF, idForn, attributes }: Props) => {

    const [idProduto, setIdProduto] = useState(0)
    const [descProd, setDescProd] = useState("")
    //const [descProdCopy, setDescProdCopy] = useState("")

    const [isGrade, setIsGrade] = useState(false)
    const [idCFOP, setIdCFOP] = useState(0)
    const [contem, setContem] = useState("0,00")
    const [qtd, setQtd] = useState("0,00")
    const [unitario, setUnitario] = useState("0,00")
    const [totItem, setTotItem] = useState("0,00")
    const [vlOut, setVlOut] = useState("0,00")
    const [vlDesc, setVlDesc] = useState("0,00")
    const [vlFrete, setVlFrete] = useState("0,00")

    const [aliqIcms, setAliqIcms] = useState("0,00")
    const [vlBcIcms, setBcIcms] = useState("0,00")
    const [vlIcms, setVlIcms] = useState("0,00")
    const [idCst, setIdCst] = useState('')
    const [vlBcSt, setVlBcSt] = useState("0,00")
    const [vlSt, setVlSt] = useState("0,00")
    const [aliqPis, setAliqPis] = useState("0,00")
    const [bcPis, setBcPis] = useState("0,00")
    const [vlPis, setVlPis] = useState("0,00")
    const [aliqCofins, setAliqCofins] = useState("0,00")
    const [bcCofins, setBcCofins] = useState("0,00")
    const [vlCofins, setVlCofins] = useState("0,00")
    const [aliqIPI, setAliqIPI] = useState("0,00")
    const [vlIPI, setVlIPI] = useState("0,00")
    const [visibleModalGrade, setVisibleModalGrade] = useState(false)
    const [gradeList, setGradeList] = useState<GradeProduto[]>([])

    const [cfopList, setCfopList] = useState<CFOP[]>([])
    const [csts, setCsts] = useState<CstICMS[]>([])

    const [produtosList, setProdutosList] = useState<Produto[]>([])
    const [linhaSelecionada, setLinhaSelecionada] = useState<number>(-1)
    //const [produtosListSelect, setProdutosListSelect]     = useState<Produto[]>([])
    //const [loadingBusca, setLoadingBusca]                 = useState(false)

    const [feedbackVisible, setFeedbackVisible] = useState<boolean>(false)
    const [feedbackType, setFeedbackType] = useState<AlertType>("DANGER")
    const [feedbackMessage, setFeedbackMessage] = useState("")

    const [loadingItem, setLoadingItem] = useState<boolean>(false)
    const [loadingPesq, setLoadingPesq] = useState(false)

    //const [visibleSearchProd, setVisibleSearchProd]   = useState<boolean>(false)
    //const [descProdBuscar, setDescProdBuscar]         = useState("")
    //const [awaitingInput, setAwaitingInput]           = useState(false) // variável auxiliar


    // -----------------------------------------------
    // ------------------ SEARCHBOX ------------------
    // -----------------------------------------------
    const [visibleSearchBoxCFOP, setVisibleSearchBoxCFOP] = useState<boolean>(false)
    const [visibleSearchBoxICMS, setVisibleSearchBoxICMS] = useState<boolean>(false)

    // -----------------------------------------------------------------------------------------------------------------------------------------------------

    // sem uso
    /*
    useEffect(() => {
        
        let newProdutosList = [...produtosList]
        newProdutosList = newProdutosList.filter(item => item.id === idProduto)

        if (newProdutosList[0] && newProdutosList[0].preco_c) {
            const precoCusto = newProdutosList[0].preco_c * 100

            setUnitario(Funcoes.MaskMoney(precoCusto.toString()) || "0,00")
            setAliqIcms(newProdutosList[0].pICMS?.toString() || "0")
            setAliqPis(newProdutosList[0].pPis?.toString() || "0")

            if (newProdutosList[0].cfopEntDentro) {
                setIdCFOP(parseInt(newProdutosList[0].cfopEntDentro))
            }

            setIdCst(newProdutosList[0].cstIcmsDentro?.toString() || '0')
        }

        console.log("teste1")

        setContem("1.00")

    }, [idProduto])

    useEffect(() => {
        
        produtosList.map((item) => {
            console.log(item.urlImage + ' ' + item.description)
        })

        if (visible) {
            setCfopList(attributes.cfops)
            setProdutosList(attributes.produtos)
            setCsts(attributes.csts)
        }
            
    }, [visible])
    */

    // -------------------------------------------------------------------------
    // USEEFFECT ---------------------------------------------------------------
    // -------------------------------------------------------------------------    
    useEffect(() => {
        const parseValor = (valor: any) => parseFloat(valor.replaceAll(".", "").replaceAll(",", "."))
        const totItem = (parseValor(qtd) * parseValor(unitario)).toFixed(2)
        setTotItem(Funcoes.numberFormat(parseFloat(totItem), 'decimal'))
    }, [qtd, unitario])

    useEffect(() => {

        const parseValor = (valor: any) => parseFloat(valor.replaceAll(".", "").replaceAll(",", "."))

        const vlBcIcms = parseValor(totItem) - parseValor(vlDesc)
        const aliqICMS = parseValor(aliqIcms)

        setVlIcms(Funcoes.numberFormat((vlBcIcms * aliqICMS), 'decimal'))
        setBcIcms(Funcoes.numberFormat((vlBcIcms), 'decimal'))

    }, [totItem, vlDesc, aliqIcms])

    useEffect(() => {

        const parseValor = (valor: any) => parseFloat(valor.replaceAll(".", "").replaceAll(",", "."))

        const vlPis = parseValor(totItem)
        const aliqPIS = parseValor(aliqPis)

        setVlPis(Funcoes.numberFormat((vlPis * aliqPIS), 'decimal'))
        setBcPis(Funcoes.numberFormat((vlPis), 'decimal'))

    }, [totItem, aliqPis])

    useEffect(() => {

        const parseValor = (valor: any) => parseFloat(valor.replaceAll(".", "").replaceAll(",", "."))

        const vlBcConfins = parseValor(totItem)
        const aliquCONFINS = parseValor(aliqCofins)

        setVlCofins(Funcoes.numberFormat((vlBcConfins * aliquCONFINS), 'decimal'))
        setBcCofins(Funcoes.numberFormat((vlBcConfins), 'decimal'))

    }, [totItem, aliqCofins])

    useEffect(() => {

        if (visible) {

            GetAttributes()

            setCfopList(attributes.cfops)
            //setProdutosList(attributes.produtos)
            setCsts(attributes.csts)
            setContem("1")

            let modal = document.getElementById('modal_itens')
            let modalContent = document.getElementById('modal_content_itens')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-1000px]')
                    modalContent.classList.add('mt-10')
                }
            }

        } else {

            let modal = document.getElementById('modal_itens')
            let modalContent = document.getElementById('modal_content_itens')

            if (modal) {
                modal.style.visibility = 'hidden'

                if (modalContent) {
                    modalContent.classList.add('mt-[-1000px]')
                    modalContent.classList.remove('mt-10')
                }
            }

            handleInputFocus()
            clearFields()
        }
    }, [visible])

    useEffect(() => {

        const inputElement = document.getElementById("descProdSearch")

        const handleKeyDown = (event: any) => {

            if (visible) {

                const { key } = event

                if (key === 'ArrowUp' || key === 'ArrowDown') {
                    event.preventDefault()

                    let nextIndex
                    if (key === 'ArrowUp') {
                        nextIndex = linhaSelecionada === -1 || linhaSelecionada === 0 ? produtosList.length - 1 : linhaSelecionada - 1
                    } else {
                        nextIndex = linhaSelecionada < produtosList.length - 1 ? linhaSelecionada + 1 : 0
                    }

                    const selectedItem = produtosList[nextIndex]

                    if (selectedItem != undefined) {

                        handleSetProdMove(selectedItem, nextIndex)
                        setLinhaSelecionada(Math.max(0, Math.min(nextIndex, produtosList.length + 1)))

                        // Scroll into view
                        const element = document.getElementById(`produto-buscar-${nextIndex}`)
                        if (element) {
                            element.scrollIntoView({
                                behavior: 'smooth',
                                block: 'nearest'
                            })
                        }

                    } else {
                        setLinhaSelecionada(-1)
                        //setProdutosList([])
                    }
                }
            }
        }

        const handleKeyPressEnter = (event: any) => {

            if ((event.code === KEY_CODE_ENTER || event.code === "NumpadEnter") && document.activeElement === inputElement && !loadingPesq) {

                if (produtosList.length > 0 && linhaSelecionada !== -1) {

                    setProdutosList([])
                    setLinhaSelecionada(-1)
                    GetAtributosTributacao(idProduto)

                    condicaoAbrirModal(idProduto)

                    //setDescProd(descProdCopy)
                    

                } else {
                    ProdutosFilter()
                }
            }

        }

        document.addEventListener('keydown', handleKeyDown)
        document.addEventListener('keydown', handleKeyPressEnter)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            document.removeEventListener('keydown', handleKeyPressEnter)
        }

    }, [produtosList, linhaSelecionada, visible, idProduto, descProd, loadingPesq])

    /*
    useEffect(() => {

        setProdutosList([])

        if (descProdCopy === '') {

            const delayDebounceFn = setTimeout(() => {

                if (descProd && descProd.length > 0) {

                    ProdutosFilter()  // Chama a função após 500 segundos de inatividade
                } else {
                    setProdutosList([])
                }
            }, 500) // 500 segundos

            setIdProduto(0)

            return () => clearTimeout(delayDebounceFn)

        } else {

            setDescProdCopy("")
            setLinhaSelecionada(-1)
        }

    }, [descProd])
    */

    const fecharModalGrade = () => {
        setVisibleModalGrade(false)
        limparCamposCancelModal()
        Inputfocus()
    }

    const GetAttributes = async () => {

        setLoadingItem(true)

        try {

            if (nitemNF > 0) {

                const attributes = await NotaEntradaService.LocalizarItemNF(idNF, nitemNF)

                if (attributes) {

                    setIdProduto(attributes.data.id_produto)
                    setDescProd(attributes.data.descricao)
                    //setDescProdCopy(attributes.descricao)
                    setIdCFOP(parseInt(attributes.data.cfop?.toString() || '0'))
                    setContem(attributes.data.contem?.toString() || '0')

                    setQtd(attributes.data.qtd ? Funcoes.numberFormat(attributes.data.qtd?.toString(), 'decimal', 2, 2) : '0,00')
                    setUnitario(attributes.data.vl_unit ? Funcoes.numberFormat(attributes.data.vl_unit?.toString(), 'decimal', 2, 2) : '0,00')
                    setTotItem(attributes.data.vl_tot ? Funcoes.numberFormat(attributes.data.vl_tot?.toString(), 'decimal', 2, 2) : '0,00')
                    setVlOut(attributes.data.vl_out ? Funcoes.numberFormat(attributes.data.vl_out?.toString(), 'decimal', 2, 2) : '0,00')
                    setVlDesc(attributes.data.vl_desc ? Funcoes.numberFormat(attributes.data.vl_desc?.toString(), 'decimal', 2, 2) : '0,00')
                    setVlFrete(attributes.data.vl_frete ? Funcoes.numberFormat(attributes.data.vl_frete?.toString(), 'decimal', 2, 2) : '0,00')
                    setAliqIcms(attributes.data.aliq_icms ? Funcoes.numberFormat(attributes.data.aliq_icms?.toString(), 'decimal', 2, 2) : '0,00')
                    setBcIcms(attributes.data.vl_bc_icms ? Funcoes.numberFormat(attributes.data.vl_bc_icms?.toString(), 'decimal', 2, 2) : '0,00')
                    setVlIcms(attributes.data.vl_icms ? Funcoes.numberFormat(attributes.data.vl_icms?.toString(), 'decimal', 2, 2) : '0,00')
                    setIdCst(attributes.data.cst_icms?.toString() || '')
                    setVlBcSt(attributes.data.vl_bc_st ? Funcoes.numberFormat(attributes.data.vl_bc_st?.toString(), 'decimal', 2, 2) : '0,00')
                    setVlSt(attributes.data.vl_st ? Funcoes.numberFormat(attributes.data.vl_st?.toString(), 'decimal', 2, 2) : '0,00')
                    setAliqPis(attributes.data.aliq_pis ? Funcoes.numberFormat(attributes.data.aliq_pis?.toString(), 'decimal', 2, 2) : '0,00')
                    setBcPis(attributes.data.vl_bc_pis ? Funcoes.numberFormat(attributes.data.vl_bc_pis?.toString(), 'decimal', 2, 2) : '0,00')
                    setVlPis(attributes.data.vl_pis ? Funcoes.numberFormat(attributes.data.vl_pis?.toString(), 'decimal', 2, 2) : '0,00')
                    setAliqCofins(attributes.data.aliq_cofins ? Funcoes.numberFormat(attributes.data.aliq_cofins?.toString(), 'decimal', 2, 2) : '0,00')
                    setBcCofins(attributes.data.vl_bc_cofins ? Funcoes.numberFormat(attributes.data.vl_bc_cofins?.toString(), 'decimal', 2, 2) : '0,00')
                    setVlCofins(attributes.data.vl_cofins ? Funcoes.numberFormat(attributes.data.vl_cofins?.toString(), 'decimal', 2, 2) : '0,00')
                    setAliqIPI(attributes.data.aliq_ipi ? Funcoes.numberFormat(attributes.data.aliq_ipi?.toString(), 'decimal', 2, 2) : '0,00')
                    setVlIPI(attributes.data.vl_ipi ? Funcoes.numberFormat(attributes.data.vl_ipi?.toString(), 'decimal', 2, 2) : '0,00')
                }

            }

        } catch (error) {

            setFeedbackVisible(true)
            setFeedbackType("DANGER")
            setFeedbackMessage("Ocorreu um erro ao buscar os dados do item")

        } finally {
            setLoadingItem(false)

            const timer = setTimeout(() => {
                Inputfocus()
                clearTimeout(timer)
            }, 150)
        }
    }

    const GetAtributosTributacao = async (id_prod: number) => {

        setLoadingItem(true)

        try {

            const attributes = await NotaEntradaService.FilterTributes(id_prod, idForn)
            if (attributes) {

                setAliqIcms(attributes.data.pICMS ? Funcoes.numberFormat(attributes.data.pICMS?.toString(), 'decimal') : '0,00')
                setAliqPis(attributes.data.pPIS ? Funcoes.numberFormat(attributes.data.pPIS?.toString(), 'decimal') : '0,00')
                setAliqCofins(attributes.data.pCOFINS ? Funcoes.numberFormat(attributes.data.pCOFINS?.toString(), 'decimal') : '0,00')
                setIdCFOP(attributes.data.cfop || 0)
                setIdCst(attributes.data.cst || '')
            }

        } catch (error) {

            setFeedbackVisible(true)
            setFeedbackType("DANGER")
            setFeedbackMessage("Ocorreu um erro ao buscar os dados da tributação")

        } finally {
            setLoadingItem(false)
        }

    }

    // -------------------------------------------------------------------------
    // INPUTS ------------------------------------------------------------------
    // -------------------------------------------------------------------------
    /*
    const handleFocus = () => {
        // Define awaitingInput como true ao recuperar o foco
        setAwaitingInput(true)
    }
    
    const handleBlur = () => {
        // Sempre desativa o visibleSearchProd ao perder o foco
        setVisibleSearchProd(false)
        //setAwaitingInput(false) // Reseta a espera por input
    }
    */

    const handleDescProd = async (e: React.ChangeEvent<HTMLInputElement>) => {
        setDescProd(e.target.value)
        setProdutosList([])
        setIdProduto(0)
        //setDescProdCopy('')
        setLinhaSelecionada(-1)
    }

    const handleChangeContem = (e: React.ChangeEvent<HTMLInputElement>) => {
        //const inputValue = Funcoes.MaskMoney(e.target.value)
        //setContem(Funcoes.numberFormat(inputValue, 'decimal'))
        setContem(e.target.value.replace(/[^0-9]/g, ''))
    }

    const handleChangeQtd = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setQtd(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeUnit = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setUnitario(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeTotItem = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setTotItem(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeVlOut = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlOut(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeVlDesc = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlDesc(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleLancaGradeFinalizado = (gradeList: GradeProduto[]) => {
        setGradeList(gradeList)
        setVisibleModalGrade(false)
        let qtd: number = 0
        for (let i in gradeList) {
            qtd += gradeList[i].valorEntrada || 0
        }

        setQtd(qtd.toString())
    }

    // CFOP DE ENTRADA ------------------------------------------------------------------
    const handleClearCfopSelecionada = useCallback(async () => {
        const newCfopList = [...attributes.cfops]
        setCfopList(newCfopList)
        setIdCFOP(0)

        setVisibleSearchBoxCFOP(false)
        boxFocusCFOP()
    }, [attributes.cfops])

    const handleFilterCfopClick = useCallback(async (description: any) => {

        let newCfopList = [...attributes.cfops]

        if (description !== "") {

            if (Funcoes.isNumber(description)) {

                newCfopList = newCfopList.filter((cfop: CFOP) => {
                    return cfop.codigo.toString().startsWith(description)
                })

            } else {

                newCfopList = newCfopList.filter((cfop: CFOP) => {
                    return cfop.description.toLocaleLowerCase().toString().startsWith(description.toLocaleLowerCase())
                })
            }
        }

        setCfopList(newCfopList)

    }, [attributes.cfops])

    const handleCfopSelectClick = useCallback(async (v: CFOP) => {

        if (v) {
            const newCfopList = [...attributes.cfops]
            setCfopList(newCfopList)
            setIdCFOP(v.id)
        }

        setVisibleSearchBoxCFOP(false)
        boxFocusCFOP()

    }, [attributes.cfops])
    // ---------------------------------------------------------------------------------

    const handleChangeAliqICMS = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setAliqIcms(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeBcICMS = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setBcIcms(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeVlICMS = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlIcms(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeAliqPis = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setAliqPis(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeBcPis = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setBcPis(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeVlPis = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlPis(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeAliqCofins = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setAliqCofins(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeBcCofins = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setBcCofins(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeVlCofins = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlCofins(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeVlBcSt = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlBcSt(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeVlSt = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlSt(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeAliqIPI = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setAliqIPI(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeVlIPI = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlIPI(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    const handleChangeVlFrete = (e: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = Funcoes.MaskMoney(e.target.value)
        setVlFrete(Funcoes.numberFormat(inputValue, 'decimal'))
    }

    // CST ICMS -----------------------------------------------------------------------
    const handleClearCstSelecionada = useCallback(() => {

        let newCstList = [...attributes.csts]
        setCsts(newCstList)
        setIdCst('')

        setVisibleSearchBoxICMS(false)
        boxFocusICMS()
    }, [attributes.csts])

    const handleFilterCstClick = useCallback((descricao: string) => {

        let newCstList = [...attributes.csts]

        if (descricao.trim() !== "") {
            newCstList = newCstList.filter(item => item.id.trim().toUpperCase().startsWith(descricao.trim().toUpperCase()))
        }
        setCsts(newCstList)
    }, [attributes.csts])

    const handleCstSelectClick = useCallback((data: any) => {

        if (data) {
            let newCstList = [...attributes.csts]
            setCsts(newCstList)
            setIdCst(data.id)
        }

        setVisibleSearchBoxICMS(false)
        boxFocusICMS()
    }, [attributes.csts])
    // ---------------------------------------------------------------------------------

    // -------------------------------------------------------------------------
    // CADASTRO E LIMPAR CAMPOS ------------------------------------------------
    // -------------------------------------------------------------------------
    const handleCadastrarItemClick = async () => {

        setFeedbackVisible(false)
        setLoadingItem(true)

        try {

            if (isGrade && gradeList.length === 0) {
                setFeedbackVisible(true)
                setFeedbackType("DANGER")
                setFeedbackMessage("Lançamento da grade não localizado")
                setLoadingItem(false)
                return
            }

            if (idProduto === 0) {
                const timer = setTimeout(() => {
                    setFeedbackVisible(true)
                    setFeedbackType("DANGER")
                    setFeedbackMessage("Produto não informado")

                    setLoadingItem(false)
                    clearTimeout(timer)
                }, 250)
                return
            }

            if (parseFloat(qtd) <= 0) {

                const timer = setTimeout(() => {
                    setFeedbackVisible(true)
                    setFeedbackType("DANGER")
                    setFeedbackMessage("Quantidade informada inválida")

                    setLoadingItem(false)
                    clearTimeout(timer)
                }, 250)
                return
            }

            if (parseFloat(unitario) <= 0) {

                const timer = setTimeout(() => {
                    setFeedbackVisible(true)
                    setFeedbackType("DANGER")
                    setFeedbackMessage("Preço de custo informado inválido")

                    setLoadingItem(false)
                    clearTimeout(timer)
                }, 250)
                return
            }

            const item: NFEntraItem = {
                id: 0,
                nitem: 0,
                id_produto: 0,
                descricao: "",
                qtd: 0,
                unid_c: "",
                contem: 0,
                vl_unit: 0,
                vl_tot: 0
            }

            item.id = idNF
            item.nitem = nitemNF || 0
            item.id_produto = idProduto
            item.qtd = parseFloat(qtd.replaceAll(".", "").replace(",", "."))
            item.unid_c = ""
            item.contem = parseInt(contem)
            item.vl_unit = parseFloat(unitario.replaceAll(".", "").replace(",", "."))
            item.vl_tot = parseFloat(totItem.replaceAll(".", "").replace(",", "."))
            item.vl_desc = parseFloat(vlDesc.replaceAll(".", "").replace(",", "."))
            item.vl_seg = parseFloat(vlFrete.replaceAll(".", "").replace(",", "."))
            item.vl_out = parseFloat(vlOut.replaceAll(".", "").replace(",", "."))
            item.vl_frete = parseFloat(vlFrete.replaceAll(".", "").replace(",", "."))
            item.vl_bc_pis = parseFloat(bcPis.replaceAll(".", "").replace(",", "."))
            item.aliq_pis = parseFloat(aliqPis.replaceAll(".", "").replace(",", "."))
            item.vl_pis = parseFloat(vlPis.replaceAll(".", "").replace(",", "."))
            item.cod_st_pis = ""
            item.vl_bc_cofins = parseFloat(bcCofins.replaceAll(".", "").replace(",", "."))
            item.aliq_cofins = parseFloat(aliqCofins.replaceAll(".", "").replace(",", "."))
            item.vl_cofins = parseFloat(vlCofins.replaceAll(".", "").replace(",", "."))
            item.vl_bc_icms = parseFloat(vlBcIcms.replaceAll(".", "").replace(",", "."))
            item.aliq_icms = parseFloat(aliqIcms.replaceAll(".", "").replace(",", "."))
            item.aliq_red_icms = 0
            item.vl_icms = parseFloat(vlIcms.replaceAll(".", "").replace(",", "."))
            item.vl_bc_ipi = 0
            item.aliq_ipi = parseFloat(aliqIPI.replaceAll(".", "").replace(",", "."))
            item.vl_ipi = parseFloat(vlIPI.replaceAll(".", "").replace(",", "."))
            item.vl_bc_st = parseFloat(vlBcSt.replaceAll(".", "").replace(",", "."))
            item.aliq_st = 0
            item.vl_st = parseFloat(vlBcSt.replaceAll(".", "").replace(",", "."))
            item.mod_bc_st = 0
            item.pmvast = 0
            item.origem = 0
            item.cst_icms = idCst.toString()
            item.cfop = idCFOP.toString()

            if (gradeList.length > 0) {
                const newGradeList: any[] = []

                gradeList.map((item) => {
                    newGradeList.push(
                        {
                            idGrade: item.id || 0,
                            qtd: item.valorEntrada || 0
                        }
                    )
                })

                item.grade = JSON.stringify(newGradeList)

            }

            const retAPI = await NotaEntradaService.CadastrarItem(item)

            if (retAPI.error) {

                const timer = setTimeout(() => {
                    setFeedbackVisible(true)
                    setFeedbackType("DANGER")
                    setFeedbackMessage(retAPI.msg || "")
                    clearTimeout(timer)
                }, 250)
                return
            }

            buttonConfirmClick(retAPI.data, nitemNF)
            clearFields()

        } catch (error) {

            setFeedbackVisible(true)
            setFeedbackType("DANGER")
            setFeedbackMessage("Ocorreu um erro ao lançar o item")

        } finally {
            setLoadingItem(false)
            Inputfocus()
        }
    }

    const clearFields = () => {
        setIdProduto(0)
        setDescProd('')
        //setDescProdCopy('')
        setContem("0,00")
        setQtd("0,00")
        setUnitario("0,00")
        setTotItem("0,00")
        setVlOut("0,00")
        setVlDesc("0,00")
        setIdCFOP(0)
        setAliqIcms("0,00")
        setBcIcms("0,00")
        setVlIcms("0,00")
        setAliqPis("0,00")
        setBcPis("0,00")
        setVlPis("0,00")
        setAliqCofins("0,00")
        setBcCofins("0,00")
        setVlCofins("0,00")
        setIdCst('')
        setVlBcSt("0,00")
        setVlSt("0,00")
        setAliqIPI("0,00")
        setVlIPI("0,00")
        setVlFrete("0,00")
        setCfopList([])
        setCsts([])
        setGradeList([])
        setLinhaSelecionada(-1)

        setFeedbackVisible(false)

    }

    const limparCamposCancelModal = () => {
        setIdProduto(0)
        setDescProd('')
        setContem("1")
        setQtd("0,00")
        setUnitario("0,00")
        setTotItem("0,00")
        setVlOut("0,00")
        setVlDesc("0,00")
        setIdCFOP(0)
        setAliqIcms("0,00")
        setBcIcms("0,00")
        setVlIcms("0,00")
        setAliqPis("0,00")
        setBcPis("0,00")
        setVlPis("0,00")
        setAliqCofins("0,00")
        setBcCofins("0,00")
        setVlCofins("0,00")
        setIdCst('')
        setVlBcSt("0,00")
        setVlSt("0,00")
        setAliqIPI("0,00")
        setVlIPI("0,00")
        setVlFrete("0,00")
        setLinhaSelecionada(-1)

        setFeedbackVisible(false)

    }

    const Inputfocus = () => {
        const inputElement = document.getElementById("descProdSearch")
        inputElement?.focus()
    }

    const handleClickOutsideInputs = (event: any) => {
        // Verifica se o elemento clicado não é um input
        if (!event.target.matches('input')) {
            setProdutosList([])
            setLinhaSelecionada(-1)
        }
    }


    // -------------------------------------------------------------------------
    // FUNÇÕES DE FILTRO DO PRODUTO --------------------------------------------
    // -------------------------------------------------------------------------
    const handleProdSelecionado = (item: any, index: number) => {

        condicaoAbrirModal(item.id)

        setIdProduto(item.id)
        setDescProd(item.descricao)
        setProdutosList([])
        setLinhaSelecionada(-1)
        GetAtributosTributacao(item.id)
    }

    const handleSetProdMove = (item: any, index: number) => {
        setIdProduto(item.id)
        setDescProd(item.descricao)
        //setDescProdCopy(item.descricao)
        setLinhaSelecionada(index)
    }

    const ProdutosFilter = async () => {

        setLoadingPesq(true)        // inicia o loading na tela para o usuario ver carregando
        setFeedbackVisible(false)   // fecha o modal de mensagem que fica no canto direito superior 
        setProdutosList([])         // limpa a lista de produtos 
        handleInputFocus()          // fecha os componentes searchBox que estiverem abertos

        try {

            const relatorio = {
                status: 'S',
            }

            const produtos = await ProdutoService.Filter('descricao', descProd, 'start', relatorio)  // requisição api
            setProdutosList(produtos.data) // resultado da api é setado na lista de produtos

        } catch (error) {

            setFeedbackVisible(true)
            setFeedbackType("DANGER")
            setFeedbackMessage("Ocorreu um erro ao buscar os produtos")

        } finally {
            Inputfocus()            // no final independente se der certo ou não a requisição o input de pesquisa ganha o focus novamente
            setLoadingPesq(false)   // fim do loading
        }
    }


    // ---------------------------------------------------------------- FOCUS ABA 1 -----------------------------------------------------------------
    const inputsRefs: InputsRefs = {
        descProd: useRef(null),
        CFOP: useRef(null),
        contem: useRef(null),
        quantidade: useRef(null),
        precoUnitario: useRef(null),
        totalItem: useRef(null),
        outrasDespesa: useRef(null),
        valorDesconto: useRef(null),
        valorFrete: useRef(null),
        aliqICMS: useRef(null),
        baseCalcICMS: useRef(null),
        valorICMS: useRef(null),
        cstICMS: useRef(null),
        baseCalcICMSst: useRef(null),
        valorICMSst: useRef(null),
        aliqPIS: useRef(null),
        baseCalcPIS: useRef(null),
        valorPIS: useRef(null),
        aliqCONFINS: useRef(null),
        baseCalcCONFINS: useRef(null),
        valorCONFINS: useRef(null),
        aliqIPI: useRef(null),
        valorIPI: useRef(null),
    }

    const handleTabPress = (event: any, inputKey: any) => {

        if (event.key === 'Tab') {

            event.preventDefault() // Evita o comportamento padrão do 'Tab'

            handleInputFocus()

            // Obtenha as chaves dos elementos em ordem
            const keys = Object.keys(inputsRefs)

            // Encontre o índice do campo atual
            let currentIndex = keys.indexOf(inputKey)
            let nextIndex = currentIndex

            // Loop para encontrar o próximo campo habilitado e focável
            do {
                nextIndex = (nextIndex + 1) % keys.length;

                const nextEl = inputsRefs[keys[nextIndex]].current;

                if (!nextEl) continue;
                if (nextEl.disabled) continue;
                if (nextEl.tabIndex === -1) continue;
                if (nextEl.offsetParent === null) continue; // está invisível (ex: display: none)

                break;
            } while (nextIndex !== currentIndex);

            if (nextIndex === 1) {

                condicaoAbrirModal(idProduto)
                GetAtributosTributacao(idProduto)

                setVisibleSearchBoxCFOP(true)
                inputFocusCFOP()
            }

            if (nextIndex === 12) {
                setVisibleSearchBoxICMS(true)
                inputFocusICMS()
            }


            // Direcione o foco para o próximo campo habilitado e focável, se encontrado
            const nextRef = inputsRefs[keys[nextIndex]].current;
            if (nextRef && typeof nextRef.focus === 'function') {
                nextRef.focus();
            }
        }
    }

    const condicaoAbrirModal = (idProduto: any) => {


        let newProdutosList = [...produtosList]
        newProdutosList = newProdutosList.filter(prod => prod.id === idProduto)

        if (newProdutosList && newProdutosList.length > 0) {
            if (newProdutosList[0].isGrade && newProdutosList[0].isGrade === true) {
                setVisibleModalGrade(true)
                setIsGrade(true)
            } else {
                setIsGrade(false)
            }
        }


    }

    useEffect(() => {

        const handleKeyDown = (event: KeyboardEvent) => {

            if (event.key === 'Tab') {

                //event.preventDefault()

                const inputSearchCFOP = document.getElementById('inputSearchBox-CFOP') as HTMLInputElement
                const inputSearchICMS = document.getElementById('inputSearchBox-cstICMS') as HTMLInputElement

                if (document.activeElement === inputSearchCFOP) {
                    inputsRefs['contem'].current?.focus()
                    setVisibleSearchBoxCFOP(false)

                } else if (document.activeElement === inputSearchICMS) {
                    inputsRefs['baseCalcICMSst'].current?.focus()
                    setVisibleSearchBoxICMS(false)
                }

            }
        }

        document.addEventListener('keydown', handleKeyDown)

        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    const handleInputFocus = () => {
        setVisibleSearchBoxCFOP(false)
        setVisibleSearchBoxICMS(false)

        if (produtosList.length > 0) {
            setProdutosList([])
            setLinhaSelecionada(-1)
            //setDescProdCopy('')
        }
    }

    // CFOP
    const boxFocusCFOP = () => {
        // Move o foco para o input correspondente à chave 'CFOP'.
        inputsRefs['CFOP'].current?.focus()
    }

    const clickSearchBoxCFOP = useCallback(() => {
        setVisibleSearchBoxCFOP((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha o SearchBoxICMS e foca no SearchBoxCFOP
                setVisibleSearchBoxICMS(false)
                inputFocusCFOP()
            }
            return newState
        })
        boxFocusCFOP()
    }, [])

    const inputFocusCFOP = () => {
        let inputSearch = document.getElementById(`inputSearchBox-CFOP`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // ICMS
    const boxFocusICMS = () => {
        // Move o foco para o input correspondente à chave 'cstICMS'.
        inputsRefs['cstICMS'].current?.focus()
    }

    const clickSearchBoxICMS = useCallback(() => {
        setVisibleSearchBoxICMS((prevState) => {
            const newState = !prevState // Alterna o estado atual
            if (newState) {
                // Fecha o SearchBoxCFOP e foca no SearchBoxICMS
                setVisibleSearchBoxCFOP(false)
                inputFocusICMS()
            }
            return newState
        })
        boxFocusICMS()
    }, [])

    const inputFocusICMS = () => {
        let inputSearch = document.getElementById(`inputSearchBox-cstICMS`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }

    // -------------------------------------------------------------------------
    // SEM USO -----------------------------------------------------------------
    // -------------------------------------------------------------------------
    const handleClearProdutosList = () => {
        //let newProdutosList = [...attributes.produtos]
        //setProdutosList(newProdutosList)
    }

    const handleSetDataClick = (data: any) => {
        //setIdProduto(data.id)
        //let newProdutosList = [...attributes.produtos]
        //setProdutosList(newProdutosList)
    }

    const filterProdutosList = async (description: string) => {
        /*
        let newProdutosList = [...attributes.produtos]

        if (description.trim() !== "") {
            newProdutosList = await ProdutoService.Filter("descricao", description, "start")
            //newProdutosList = newProdutosList.filter( item => item.descricao.trim().toUpperCase().startsWith(description.trim().toUpperCase()))
        }

        setProdutosList(newProdutosList)
        */
    }

    const alturaLP_LR = 'h-[1720px] sm:h-[990px] lg:h-[740px]'
    const alturaMEI = 'h-[500px]  sm:h-[320px] lg:h-[260px]'
    const alturaSN = 'h-[1280px] sm:h-[800px] lg:h-[570px]'

    return (

        <div id="modal_itens" onClick={handleClickOutsideInputs} style={{ visibility: visible ? "visible" : "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40 overflow-auto`}>

            <div id="modal_content_itens" className={`relative flex flex-col w-[90%] ${regimeTributario === "MEI" ? `${alturaMEI} xl:w-[60%]` : regimeTributario === "SN" ? `${alturaSN} xl:w-[70%] 2xl:w-[60%]` : `${alturaLP_LR} xl:w-[70%] 2xl:w-[60%]`} bg-white dark:bg-slate-600 rounded-lg mt-[-1000px] transition-all duration-300 justify-center items-center mb-8`} >

                <FeedbackMessage visible={feedbackVisible} message={feedbackMessage} type={feedbackType} onCloseMessage={() => setFeedbackVisible(false)} />

                <div className={`absolute top-0 w-full h-[60px] flex items-center`} >

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <FaFolderClosed size={20} className="w-5 h-5 text-slate-700 dark:text-slate-200" />
                    </div>

                    <div className={`flex flex-row items-center`}>
                        <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Cadastrar item da nota fiscal</span>

                        <FaRegQuestionCircle tabIndex={-1} data-tooltip-id={'tooltip-btn-question'} id={'btn-question'} className={`text-[#ACACAC] dark:text-slate-300 ml-2`} size={18} />
                        <Tooltip id={'tooltip-btn-question'} anchorSelect={'#btn-question'} positionStrategy="fixed" place='right' >
                            <span >Os campos com borda <br /> vermelha são obrigatórios</span>
                        </Tooltip>
                    </div>
                </div>

                <div className={`absolute top-[60px] bottom-[60px] w-full px-1`}>

                    <div className={`grid grid-cols-12 gap-3 w-full p-2`}>

                        <div className={`relative col-span-12`}>

                            <div className={`relative w-full h-[45px] flex items-center`}>

                                <div className={`flex items-center justify-center`}>
                                    <button id="buttonProdSearch" className={`absolute h-[43px] w-10 right-[1px] z-10 border bg-slate-300 hover:bg-slate-600 transition-colors duration-300 border-slate-400 border-y-0 border-r-0 dark:bg-slate-500 dark:hover:bg-slate-800 dark:border-slate-700 dark:focus:border-slate-400" rounded-r-md `} onClick={ProdutosFilter}>
                                        <div className={`w-full h-full flex justify-center items-center text-slate-700 hover:text-slate-300 dark:text-slate-100`}>
                                            {!loadingPesq &&
                                                <IoSearch className={`h-[18px] w-[18px]`} />
                                            }
                                            {loadingPesq &&

                                                <div className={`z-10 absolute mx-2 inline-block h-[18px] w-[18px] animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-blue-400 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                                    <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                                                </div>
                                            }
                                        </div>
                                    </button>
                                </div>
                                <div className={`${barraVermelhoAzul} ${idProduto > 0 ? bgBlue : bgRed}`} />
                                <input ref={inputsRefs.descProd} onKeyDown={(e) => handleTabPress(e, 'descProd')} id='descProdSearch' className={`${classInput} ${classInputDark} ${idProduto > 0 ? '' : focusRed} pr-14`} type="text" inputMode="text" placeholder='Digite o nome do produto e pressione Enter ou clique na lupa para buscar o produto'
                                    autoComplete='off' value={descProd} onFocus={handleInputFocus} onChange={handleDescProd} />
                                <label htmlFor="descProdSearch" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${idProduto > 0 ? '' : focusLabelRed}`}>Descrição</label>
                            </div>

                            {produtosList.length > 0 &&

                                <div className={`absolute left-0 right-0 bg-slate-50 dark:bg-[#475569] z-40`}>

                                    <div className={`max-h-[460px] overflow-auto scrollbar-track-transparent scrollbar-thumb-slate-400 dark:scrollbar-thumb-slate-800 scrollbar-thin dark:scrollbar-thin`}>

                                        <div className={`w-full h-auto bg-slate-50 dark:bg-[#475569] text-black dark:text-slate-200`}>

                                            <ul id='elementos' className={`w-full`}>
                                                {produtosList.length > 0 &&
                                                    produtosList.map((item, index) => {
                                                        return (

                                                            <li key={item.id} id={`produto-buscar-${index}`} onClick={() => handleProdSelecionado(item, index)} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all border-2 ${index === linhaSelecionada ? ' border-slate-400 bg-slate-200 dark:bg-slate-500' : 'border-white dark:border-slate-600'} cursor-pointer`}>

                                                                <div className={`w-full flex flex-col min-h-[70px] h-auto font-mono border border-slate-300 dark:border-slate-800`}>

                                                                    <div className="flex flex-row ">

                                                                        <div className={`flex items-center w-[9%] break-all`}>

                                                                            {item.urlImage ?
                                                                                <img className={`w-12 h-12 ml-4 transform-gpu hover:scale-[1.7] transition-all duration-150 cursor-pointer`} src={item.urlImage} alt="fotoProduto" />
                                                                                :

                                                                                <MdPhotoCamera className={`w-12 h-12 ml-4 transform-gpu hover:scale-[1.7] transition-all duration-150 cursor-pointer`} />
                                                                            }
                                                                        </div>

                                                                        <div className={`flex flex-col w-full`}>

                                                                            <div className={`flex flex-col justify-center w-full space-y-2 break-all`}>

                                                                                <div className="">
                                                                                    <span className={`px-2 text-[18px] font-semibold`}>{'Descrição: ' + (item.descricao || '')}</span>
                                                                                </div>

                                                                            </div>

                                                                            <div className={`flex flex-row`}>

                                                                                <div className={`flex flex-col justify-center w-full space-y-2 break-all`}>

                                                                                    <div className="">
                                                                                        <span className={`px-2 text-xs`}>{'Estoque: ' + (item.estoque_fisico || '0')}</span>
                                                                                    </div>

                                                                                    <div className="">
                                                                                        <span className={`px-2 text-xs`}>{'Fornecedor: ' + (item.nome_fornecedor || '')}</span>
                                                                                    </div>

                                                                                </div>

                                                                                <div className={`flex flex-col justify-center w-full space-y-2 break-all`}>
                                                                                    <div className="">
                                                                                        <span className={`px-2 text-xs`}>{'Data da ultima compra: ' + (item.dt_ult_compra ? moment(item.dt_ult_compra).format("DD/MM/YYYY") : '')}</span>
                                                                                    </div>

                                                                                    <div className="">
                                                                                        <span className={`px-2 text-xs`}>{'Valor da ultima compra: ' + (item.vl_custo_ult_compra ? Funcoes.numberFormat(item.vl_custo_ult_compra || 0, 'currency') : '')}</span>
                                                                                    </div>

                                                                                </div>

                                                                                <div className={`flex flex-col justify-center w-full space-y-2 break-all`}>
                                                                                    <div className="">
                                                                                        <span className={`px-2 text-xs`}>{'Qtde da ultima compra: ' + (item.qtd_ult_compra ? Funcoes.numberFormat(item.qtd_ult_compra || 0, 'decimal') : '')}</span>
                                                                                    </div>

                                                                                    <div className="">
                                                                                        <span className={`px-2 text-xs`}>{'NF da ultima compra: ' + (item.num_nf_ult_compra ? item.num_nf_ult_compra : '')}</span>
                                                                                    </div>

                                                                                </div>

                                                                            </div>

                                                                        </div>

                                                                    </div>

                                                                </div>

                                                            </li>
                                                        )
                                                    })
                                                }

                                            </ul>

                                        </div>

                                    </div>

                                </div>
                            }

                        </div>

                        <div className={`relative col-span-12 lg:col-span-10 mt-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>

                            <div ref={inputsRefs['CFOP']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'CFOP')} />
                            <div className={`${barraVermelhoAzul} ${idCFOP > 0 ? bgBlue : bgRed}`} />
                            <SearchBox
                                dataList={cfopList}
                                idRegistro={idCFOP}
                                label="CFOP de entrada"
                                componentId='CFOP'
                                limite={true}
                                borda={true}
                                visibleTAB={visibleSearchBoxCFOP}
                                clearDataClick={handleClearCfopSelecionada}
                                setDataClick={handleCfopSelectClick}
                                filterDataClick={handleFilterCfopClick}
                                clicado={clickSearchBoxCFOP}
                            />
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 lg:col-span-2 mt-1`}>
                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                            <input ref={inputsRefs.contem} onKeyDown={(e) => handleTabPress(e, 'contem')} id="contem_item" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={contem} onFocus={handleInputFocus} onChange={handleChangeContem} />
                            <label htmlFor="contem_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Contém</label>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 lg:col-span-2 mt-1`}>
                            <div className={`${barraVermelhoAzul} ${qtd !== '0,00' ? bgBlue : bgRed}`} />
                            <input disabled={gradeList.length > 0} ref={inputsRefs.quantidade} onKeyDown={(e) => handleTabPress(e, 'quantidade')} id="qtd_item" className={`${classInput} disabled:opacity-40 ${classInputDark} ${qtd !== '0,00' ? '' : focusRed} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={qtd} onFocus={handleInputFocus} onChange={handleChangeQtd} />
                            <label htmlFor="qtd_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${qtd != '0,00' ? '' : focusLabelRed}`}>Quantidade</label>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 lg:col-span-2 mt-1`}>
                            <div className={`${barraVermelhoAzul} ${unitario != '0,00' ? bgBlue : bgRed}`} />
                            <input ref={inputsRefs.precoUnitario} onKeyDown={(e) => handleTabPress(e, 'precoUnitario')} id="preco_unit_item" className={`${classInput} ${classInputDark} ${unitario != '0,00' ? '' : focusRed} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={unitario} onFocus={handleInputFocus} onChange={handleChangeUnit} />
                            <label htmlFor="preco_unit_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark} ${unitario != '0,00' ? '' : focusLabelRed}`}>Preço Unitário</label>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 lg:col-span-2 mt-1`}>
                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                            <input ref={inputsRefs.totalItem} onKeyDown={(e) => handleTabPress(e, 'totalItem')} id="tot_item" disabled={true} className={`${classInput} ${classInputDark} disabled:bg-gray-100 `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={totItem} onFocus={handleInputFocus} onChange={handleChangeTotItem} />
                            <label htmlFor="tot_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Total do item</label>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 lg:col-span-2 mt-1`}>
                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                            <input ref={inputsRefs.outrasDespesa} onKeyDown={(e) => handleTabPress(e, 'outrasDespesa')} id="vl_out_item" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlOut} onFocus={handleInputFocus} onChange={handleChangeVlOut} />
                            <label htmlFor="vl_out_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Outras Despesas</label>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 lg:col-span-2 mt-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                            <input ref={inputsRefs.valorDesconto} onKeyDown={(e) => handleTabPress(e, 'valorDesconto')} id="vl_desconto_item" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlDesc} onFocus={handleInputFocus} onChange={handleChangeVlDesc} />
                            <label htmlFor="vl_desconto_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do Desconto</label>
                        </div>

                        <div className={`relative col-span-12 sm:col-span-4 lg:col-span-2 mt-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                            <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                            <input ref={inputsRefs.valorFrete} onKeyDown={(e) => handleTabPress(e, 'valorFrete')} id="vl_frete_item" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlFrete} onFocus={handleInputFocus} onChange={handleChangeVlFrete} />
                            <label htmlFor="vl_frete_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do Frete</label>
                        </div>

                    </div>

                    {/* Dados do imposto do item */}

                    <div className="flex flex-col">

                        <div className="flex flex-col lg:flex-row">

                            <div className={`grid grid-cols-12 gap-3 w-full p-2 ${regimeTributario === "MEI" ? "hidden" : ""}`}>

                                <div className={`relative col-span-12 space-y-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                                    <div className={`flex flex-row `}>
                                        <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>ICMS</span>
                                    </div>
                                    <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 mt-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.aliqICMS} onKeyDown={(e) => handleTabPress(e, 'aliqICMS')} id="aliq_icms_item" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={aliqIcms} onFocus={handleInputFocus} onChange={handleChangeAliqICMS} />
                                    <label htmlFor="aliq_icms_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Alíquota ICMS</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 mt-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.baseCalcICMS} onKeyDown={(e) => handleTabPress(e, 'baseCalcICMS')} id="bc_icms_item" disabled={true} className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlBcIcms} onFocus={handleInputFocus} onChange={handleChangeBcICMS} />
                                    <label htmlFor="bc_icms_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Base Cálc. ICMS</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 mt-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.valorICMS} onKeyDown={(e) => handleTabPress(e, 'valorICMS')} id="valor_icms_item" disabled={true} className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlIcms} onFocus={handleInputFocus} onChange={handleChangeVlICMS} />
                                    <label htmlFor="valor_icms_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do ICMS</label>
                                </div>

                                <div className={`relative col-span-12 mt-1 ${regimeTributario === "MEI" ? "hidden" : ''}`}>

                                    <div ref={inputsRefs['cstICMS']} tabIndex={0} onKeyDown={(e) => handleTabPress(e, 'cstICMS')} />
                                    <div className={`${barraVermelhoAzul} ${idCst != "" ? bgBlue : bgRed}`} />
                                    <SearchBox
                                        dataList={csts}
                                        idRegistro={idCst}
                                        label='Cst do ICMS'
                                        componentId='cstICMS'
                                        limite={true}
                                        borda={true}
                                        visibleTAB={visibleSearchBoxICMS}
                                        clearDataClick={handleClearCstSelecionada}
                                        setDataClick={handleCstSelectClick}
                                        filterDataClick={handleFilterCstClick}
                                        clicado={clickSearchBoxICMS}
                                    />
                                </div>

                            </div>

                            <div className={`grid grid-cols-12 gap-3 w-full lg:h-[50px] p-2 ${regimeTributario === "MEI" ? "hidden" : ""}`}>

                                <div className={`relative col-span-12 space-y-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                                    <div className={`flex flex-row `}>
                                        <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>ICMS - ST</span>
                                    </div>
                                    <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                </div>

                                <div className={`relative col-span-12 sm:col-span-6 mt-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.baseCalcICMSst} onKeyDown={(e) => handleTabPress(e, 'baseCalcICMSst')} id="bc_st_item" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlBcSt} onFocus={handleInputFocus} onChange={handleChangeVlBcSt} />
                                    <label htmlFor="bc_st_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Báse Cálc. ICMS ST</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-6 mt-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.valorICMSst} onKeyDown={(e) => handleTabPress(e, 'valorICMSst')} id="vl_st_item" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlSt} onFocus={handleInputFocus} onChange={handleChangeVlSt} />
                                    <label htmlFor="vl_st_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do ICMS ST</label>
                                </div>

                            </div>

                        </div>

                        <div className="flex flex-col lg:flex-row ">

                            <div className={`grid grid-cols-12 gap-3 w-full p-2 ${regimeTributario === "MEI" || regimeTributario === "SN" ? "hidden" : ""}`}>

                                <div className={`relative col-span-12 space-y-1 ${regimeTributario === "MEI" || regimeTributario === "SN" ? "hidden" : ""}`}>
                                    <div className={`flex flex-row `}>
                                        <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>PIS</span>
                                    </div>
                                    <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 mt-1 ${regimeTributario === "MEI" || regimeTributario === "SN" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.aliqPIS} onKeyDown={(e) => handleTabPress(e, 'aliqPIS')} id="aliq_pis_item" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={aliqPis} onFocus={handleInputFocus} onChange={handleChangeAliqPis} />
                                    <label htmlFor="aliq_pis_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Alíquota de PIS</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 mt-1 ${regimeTributario === "MEI" || regimeTributario === "SN" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.baseCalcPIS} onKeyDown={(e) => handleTabPress(e, 'baseCalcPIS')} id="bc_pis_item" disabled={true} className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={bcPis} onFocus={handleInputFocus} onChange={handleChangeBcPis} />
                                    <label htmlFor="bc_pis_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Base de Cálc. do PIS</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 mt-1 ${regimeTributario === "MEI" || regimeTributario === "SN" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.valorPIS} onKeyDown={(e) => handleTabPress(e, 'valorPIS')} id="vl_pis_item" disabled={true} className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlPis} onFocus={handleInputFocus} onChange={handleChangeVlPis} />
                                    <label htmlFor="vl_pis_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do PIS</label>
                                </div>

                            </div>

                            <div className={`grid grid-cols-12 gap-3 w-full p-2 ${regimeTributario === "MEI" || regimeTributario === "SN" ? "hidden" : ""}`}>

                                <div className={`relative col-span-12 space-y-1 ${regimeTributario === "MEI" || regimeTributario === "SN" ? "hidden" : ""}`}>
                                    <div className={`flex flex-row `}>
                                        <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>CONFINS</span>
                                    </div>
                                    <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 mt-1 ${regimeTributario === "MEI" || regimeTributario === "SN" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.aliqCONFINS} onKeyDown={(e) => handleTabPress(e, 'aliqCONFINS')} id="aliq_cofins_item" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={aliqCofins} onFocus={handleInputFocus} onChange={handleChangeAliqCofins} />
                                    <label htmlFor="aliq_cofins_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Alíquota de COFINS</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 mt-1 ${regimeTributario === "MEI" || regimeTributario === "SN" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.baseCalcCONFINS} onKeyDown={(e) => handleTabPress(e, 'baseCalcCONFINS')} id="bc_cofins_item" disabled={true} className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={bcCofins} onFocus={handleInputFocus} onChange={handleChangeBcCofins} />
                                    <label htmlFor="bc_cofins_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Base de Cálc. do COFINS</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 mt-1 ${regimeTributario === "MEI" || regimeTributario === "SN" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.valorCONFINS} onKeyDown={(e) => handleTabPress(e, 'valorCONFINS')} id="vl_cofins_item" disabled={true} className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlCofins} onFocus={handleInputFocus} onChange={handleChangeVlCofins} />
                                    <label htmlFor="vl_cofins_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do COFINS</label>
                                </div>

                            </div>

                        </div>

                        <div className="flex flex-col lg:flex-row">

                            <div className={`grid grid-cols-12 gap-3 w-full lg:w-[50%] p-2 ${regimeTributario === "MEI" ? "hidden" : ""}`}>

                                <div className={`relative col-span-12 space-y-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                                    <div className={`flex flex-row `}>
                                        <span className={`text-[14px] text-[#ACACAC] dark:text-slate-300 mr-2`}>IPI</span>
                                    </div>
                                    <hr className={`border-0 h-px bg-slate-300 dark:bg-slate-700`} />
                                </div>

                                <div className={`relative col-span-12 sm:col-span-6 mt-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.aliqIPI} onKeyDown={(e) => handleTabPress(e, 'aliqIPI')} id="aliq_ipi_item" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={aliqIPI} onFocus={handleInputFocus} onChange={handleChangeAliqIPI} />
                                    <label htmlFor="aliq_ipi_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Alíquota de IPI</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-6 mt-1 ${regimeTributario === "MEI" ? "hidden" : ""}`}>
                                    <div className={`${barraVermelhoAzul} ${bgBlue}`} />
                                    <input ref={inputsRefs.valorIPI} onKeyDown={(e) => handleTabPress(e, 'valorIPI')} id="vl_ipi_item" className={`${classInput} ${classInputDark} `} type="text" inputMode="numeric" placeholder=" " autoComplete="off" value={vlIPI} onFocus={handleInputFocus} onChange={handleChangeVlIPI} />
                                    <label htmlFor="vl_ipi_item" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor do IPI</label>
                                </div>

                            </div>

                        </div>

                    </div>

                    {/* Dados do imposto do item */}

                </div>

                {loadingItem &&

                    <div className={`absolute top-[60px] bottom-[60px] w-full pt-4 bg-white dark:bg-slate-600 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button
                        tabIndex={-1}
                        disabled={loadingItem}
                        onClick={handleModalClose}
                        className={`${classbtColunasVermelho} max-w-[150px]`} >
                        CANCELAR
                    </button>

                    <button
                        tabIndex={-1}
                        disabled={loadingItem}
                        onClick={handleCadastrarItemClick}
                        className={`${classbtAzul} ${classBt} max-w-[150px]`}>
                        {loadingItem &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-white dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        CADASTRAR
                    </button>

                </div>

                <ModalLancaGradeProdutos
                    visible={visibleModalGrade}
                    loading={loading}
                    idProd={idProduto}
                    closeModalEvent={fecharModalGrade}
                    LancamentoEfetuadoItemNFClick={handleLancaGradeFinalizado}
                />

            </div>


        </div>
    )

})